import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { LocaleService } from '@sm360/widget-commons-core-services';
import { Card, CardSection } from '@sm360/ui-library';
import ShowroomCBBService from 'trade-in/services/ShowroomCBBService/ShowroomCBBService.js';
import 'trade-in/components/InstantEstimateWrapper/Steps/ErrorInspection/ErrorInspection.scss';
import ActionButton from '../../Components/ActionButton/ActionButton.jsx';

const ErrorInspection = ({ tradeInVehicle, error, onPreviousStep, onNextStep }) => {
    const { questionError, answerError, currentQuestionsAnswers } = error;
    const [errorAPI, setErrorAPI] = useState(false);

    const handleErrorNextClick = () => {
        // update the tradeInVehicle token with the current condition report
        const selectedOptions = tradeInVehicle?.selectedVehicleOptions
            ? tradeInVehicle?.selectedVehicleOptions.map((option) => option.code)
            : null;

        ShowroomCBBService.updateTradeVehicleToken(
            tradeInVehicle.tradeVehicleToken,
            tradeInVehicle?.odometer,
            tradeInVehicle?.exteriorColor?.description,
            selectedOptions,
            currentQuestionsAnswers,
            null, // for interiorTrim
            true // for noValuation
        )
            .then((result) => {
                tradeInVehicle.tradeVehicleToken = result.tradeVehicleToken;
                tradeInVehicle.formattedConditionReport = currentQuestionsAnswers;
                return onNextStep(tradeInVehicle);
            })
            .catch(() => {
                setErrorAPI(true);
            });
    };

    return (
        <div className="error-inspection-form">
            <icon
                className={
                    LocaleService.getSimpleLocale() === 'fr'
                        ? 'icon-cbb-icons-alert-message-fr'
                        : 'icon-cbb-icons-alert-message-en'
                }
            />
            <div className="error-inspection-form--title">
                {LocaleService.t('TRADE_IN.SECTIONS_CONTENT.ERROR_INSPECTION.TITLE')}
            </div>
            {errorAPI && (
                // Display an error box if CBB API returns an error on token update
                <div className="API-error-msg">
                    <Card color="alert" outline>
                        <CardSection>
                            <icon className="icon-Warning" />
                            <p>{LocaleService.t('TRADE_IN.ERROR_FETCHING')}</p>
                        </CardSection>
                    </Card>
                </div>
            )}
            <div className="error-inspection-form--description">
                {questionError &&
                    answerError && (
                        <p>
                            <span>{`${questionError} `}</span>
                            <span className="error-inspection-answer">{answerError}</span>
                        </p>
                    )}
                <p className="sr-text">
                    {LocaleService.t('TRADE_IN.SECTIONS_CONTENT.ERROR_INSPECTION.DESCRIPTION_CONTINUE')}
                </p>
                <p className="sr-text">
                    {LocaleService.t('TRADE_IN.SECTIONS_CONTENT.ERROR_INSPECTION.DESCRIPTION_BACK')}
                </p>
            </div>
            <section className="clearfix vehicle-buttons-container" data-test="trade-in.vehicle-form.submit">
                <div className="vehicle-buttons">
                    <ActionButton noPrefix onClick={onPreviousStep}>
                        {LocaleService.t('TRADE_IN.BUTTONS.BACK')}
                    </ActionButton>
                    <ActionButton next noPrefix onClick={handleErrorNextClick}>
                        {LocaleService.t('TRADE_IN.BUTTONS.CONTINUE')}
                    </ActionButton>
                </div>
            </section>
        </div>
    );
};

ErrorInspection.propTypes = {
    error: PropTypes.object,
    onPreviousStep: PropTypes.func,
    onNextStep: PropTypes.func,
};

ErrorInspection.displayName = 'ErrorInspection';

export default ErrorInspection;
